// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.root {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  width: 152px;
  font-size: 16px;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #002129;
  font-family: Inter, sans-serif;
}

.east {
  text-decoration: none;
  width: 75px;
  font-weight: 700;
  color: inherit;
  display: inline-block;
  box-sizing: border-box;
  padding: 0 20px;
}

.frame-parent,
.logo-container {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-direction: row;
  justify-content: flex-start;
}

.frame-parent {
  align-self: stretch;
  opacity: 0.8;
  font-size: 12px;
  color: #fff;
}

.logo-container {
  flex: 1 1;
  flex-direction: column;
}

.logo-icon {
  width: 32px;
  height: 32px;
  object-fit: cover;
  flex-shrink: 0;
  overflow: hidden;
  border: 1px solid #002129; /* Added border */
}

.w-label {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 26px;
  letter-spacing: 0.46px;
  line-height: 26px;
  align-self: stretch;
  color: inherit;
}`, "",{"version":3,"sources":["webpack://./src/components/GameModals/SurvivorModals/SurvivorUserStats/SurvivorUserStats.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;EACA,QAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,cAAA;EACA,8BAAA;AACJ;;AAEE;EACE,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,sBAAA;EACA,eAAA;AACJ;;AAEE;;EAEE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,2BAAA;AACJ;;AAEE;EACE,mBAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;AACJ;;AAEE;EACE,SAAA;EACA,sBAAA;AACJ;;AAEE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,yBAAA,EAAA,iBAAA;AACJ;;AAEE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,sBAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;AACJ","sourcesContent":[".root {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-start;\n    gap: 8px;\n    width: 152px;\n    font-size: 16px;\n    line-height: normal;\n    letter-spacing: normal;\n    text-align: center;\n    color: #002129;\n    font-family: Inter, sans-serif;\n  }\n  \n  .east {\n    text-decoration: none;\n    width: 75px;\n    font-weight: 700;\n    color: inherit;\n    display: inline-block;\n    box-sizing: border-box;\n    padding: 0 20px;\n  }\n  \n  .frame-parent,\n  .logo-container {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    flex-direction: row;\n    justify-content: flex-start;\n  }\n  \n  .frame-parent {\n    align-self: stretch;\n    opacity: 0.8;\n    font-size: 12px;\n    color: #fff;\n  }\n  \n  .logo-container {\n    flex: 1;\n    flex-direction: column;\n  }\n  \n  .logo-icon {\n    width: 32px;\n    height: 32px;\n    object-fit: cover;\n    flex-shrink: 0;\n    overflow: hidden;\n    border: 1px solid #002129; /* Added border */\n  }\n  \n  .w-label {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 26px;\n    letter-spacing: 0.46px;\n    line-height: 26px;\n    align-self: stretch;\n    color: inherit;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
